import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/context/LangContext";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import AppHome from "@/pages/AppHome";
import SharePlayer from "@/pages/SharePlayer";
import VideoPage from "@/pages/VideoPage";

function App() {
  useEffect(() => {
    document.title = "E-PISNYA — твоя ідея, наша музика";
  }, []);
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/app" element={<AppHome />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/s/:code" element={<SharePlayer />} />
          <Route path="/v/:vid" element={<VideoPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" richColors />
    </LangProvider>
  );
}

export default App;
